import React from "react";
import type { MarbleControls } from "./marble-controls";
export const MarbleControlsContext = React.createContext<MarbleControls | null>(
  null
);
